import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import AdSense from "./AdSense";

const LandingPage = () => {
  const features = [
    {
      title: "Timeline Calculator",
      description:
        "Generate a precise schedule for your sourdough baking process",
      icon: "🕒",
      link: "/timeline",
    },
    {
      title: "Recipes",
      description: "Classic sourdough recipes from trusted sources",
      icon: "📝",
      link: "/recipes",
    },
    {
      title: "Temperature Guide",
      description: "Understand how temperature affects fermentation times",
      icon: "🌡️",
      link: "/temperature-guide",
    },
    {
      title: "Troubleshooting",
      description: "Solutions for common sourdough baking issues",
      icon: "🔧",
      link: "/troubleshooting",
    },
    {
      title: "Bread Glossary",
      description: "Learn essential bread-making terminology",
      icon: "📖",
      link: "/glossary",
    },
    {
      title: "Hydration Calculator",
      description: "Calculate and adjust your dough's hydration levels",
      icon: "💧",
      link: "/hydration",
    },
    {
      title: "Starter Calculator",
      description: "Perfect your starter feeding ratios",
      icon: "🌱",
      link: "/starter",
    },
    {
      title: "Baker's Percentage",
      description: "Calculate ingredient ratios using baker's percentages",
      icon: "⚖️",
      link: "/bakers-percentage",
    },
    {
      title: "Shop Equipment",
      description: "Find the perfect tools for your sourdough journey",
      icon: "🛍️",
      link: "/products",
    },
  ];

  return (
    <Container className="py-5">
      {/* Hero Section */}
      <Row className="mb-5 text-center">
        <Col>
          <h1 className="display-4 mb-3">Welcome to Sourdough Math</h1>
          <p className="lead mb-4">
            Your perfect companion for crafting delicious sourdough bread. Take
            the guesswork out of timing and create consistently great loaves.
          </p>
          <Link to="/timeline">
            <Button variant="primary" size="lg" className="mb-3">
              Start Baking Now
            </Button>
          </Link>
        </Col>
      </Row>

      {/* Features Grid */}
      <Row className="g-4">
        {features.map((feature, index) => (
          <Col key={index} md={6} lg={3}>
            <Card className="h-100 text-center hover-shadow">
              <Card.Body>
                <div className="display-4 mb-3">{feature.icon}</div>
                <Card.Title>{feature.title}</Card.Title>
                <Card.Text>{feature.description}</Card.Text>
                <Link to={feature.link}>
                  <Button variant="outline-primary">Try Now</Button>
                </Link>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* AdSense Display Ad */}
      <Row className="my-5">
        <Col>
          <AdSense adSlot="landing-page-ad" />
        </Col>
      </Row>

      {/* Benefits Section */}
      <Row className="mt-5 py-5">
        <Col md={6} className="mb-4">
          <h2>Why Use Sourdough Math?</h2>
          <ul className="list-unstyled">
            <li className="mb-3">✨ Perfect timing for each baking step</li>
            <li className="mb-3">
              🌡️ Interactive temperature-based adjustments
            </li>
            <li className="mb-3">🔧 Expert troubleshooting guidance</li>
            <li className="mb-3">📖 Comprehensive bread-making glossary</li>
            <li className="mb-3">📱 Mobile-friendly interface</li>
            <li className="mb-3">🌙 Dark mode support</li>
            <li className="mb-3">🔄 Customizable process durations</li>
          </ul>
        </Col>
        <Col md={6}>
          <div
            className="p-4 rounded"
            style={{ backgroundColor: "var(--bs-light-bg-subtle)" }}
          >
            <h3>Get Started</h3>
            <p>
              Begin your sourdough journey with our comprehensive tools. Use the
              Timeline Calculator to plan your bake, check the Temperature Guide
              for optimal conditions, and refer to our Troubleshooting Guide and
              Glossary whenever you need help.
            </p>
            <Link to="/timeline">
              <Button variant="success">Create Your Timeline</Button>
            </Link>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default LandingPage;
